var padding = {
  xs: 16,
  sm: 16,
  md: 20,
  lg: 20,
  xl: 20
};
export var pageContainerPortalTokens = {
  maxWidth: {
    xs: "100%",
    sm: "100%",
    md: 960 + padding.md * 2,
    lg: 1164 + padding.lg * 2,
    xl: 1632 + padding.xl * 2
  },
  // Эти значения могут использоваться в портале. О изменениях типа или структуры нужно предупредить команду портала
  paddingX: {
    xs: padding.xs,
    sm: padding.sm,
    md: padding.md
    /*
     * lg: `0 ${padding.lg}px`,
     * xl: `0 ${padding.xl}px`
     */

  }
};